<template>
  <div class="skeleton" :class="{ 'skeleton-animated': animated }" :style="skeletonStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Определяем пропсы
const props = defineProps({
  width: {
    type: String,
    default: "100%", // Ширина по умолчанию
  },
  height: {
    type: String,
    default: "16px", // Высота по умолчанию
  },
  animated: {
    type: Boolean,
    default: true, // Анимация включена по умолчанию
  },
  borderRadius: {
    type: String,
    default: "4px", // Радиус скругления
  },
});

// Вычисляем стиль скелетона
const skeletonStyle = computed(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.borderRadius,
}));
</script>

<style scoped>
.skeleton {
  background-color: #e0e0e0;
  overflow: hidden;
  position: relative;
}

.skeleton-animated::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: skeleton-animation 1.5s infinite;
}

@keyframes skeleton-animation {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
